module.exports = __webpack_public_path__ + "static/media/Ahmad Backbase.f8934771.png";